import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useParams } from 'react-router-dom';
import { SearchFilter } from 'types/Filters';
import { PaginationItems } from 'types/Pagination';
import listOrganizationEnvironments from 'api/Organization/listOrganizationEnvironments';

export interface OrganizationEnvironments {
    owner: string;
    SamlGroupName: string;
    AwsAccountId: string;
    created: string;
    label: string;
    environmentUri: string;
    AwsProdAccountId: string;
    AwsDevAccountId: string;
    AwsTestAccountId: string;
    AwsToolAccountId: string;
    AwsValAccountId: string;
}
export default function useEnvironmentList(filter: SearchFilter) {
    const client = useClient();
    const { openAlert } = useAlert();
    const params = useParams<{ uri: string }>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [environments, setEnvironments] = useState<
        OrganizationEnvironments[]
    >([]);
    const [tableItems, setItems] = useState<PaginationItems>({
        count: 0,
        pages: 0,
        page: 0,
    });

    useEffect(() => {
        const fetchData = async () => {
            if (params.uri)
                try {
                    setLoading(true);
                    const response = await client?.query(
                        listOrganizationEnvironments(params.uri, filter),
                    );
                    if (!response.errors) {
                        setEnvironments(
                            response.data.getOrganization.environments.nodes,
                        );
                        setItems(response.data.getOrganization.environments);
                    } else {
                        setError(true);
                        openAlert({
                            message: response.errors[0]?.message,
                            severity: 'alert',
                        });
                    }
                } finally {
                    setLoading(false);
                }
        };

        if (client) {
            fetchData();
        }
    }, [client, params.uri, filter]);

    return {
        environments,
        error,
        loading,
        tableItems,
    };
}
